@use "styles/mixins/_fonts.scss" as fonts;

.subsection-title {
  @include fonts.title4;

  margin-bottom: var(--size-spacing-l);
  overflow-wrap: anywhere;
}
